export const teamKeys = {
  all: ['team'] as const,
  members: () => [...teamKeys.all, 'members'] as const,
  memberProfile: (memberId: string) => [...teamKeys.all, 'member-profile', memberId] as const,
  mutations: () => [...teamKeys.all, 'mutations'] as const,
} as const;
